// extracted by mini-css-extract-plugin
module.exports = {"logoImage":"_______Mobile_logoImage__X3yLD"};